import { getTestAB } from '@catalogo/core-experiments';
import { ApolloClient } from '@apollo/client';

interface Callback {
  (): void;
}
export const canaryScripts = (name: string, client: ApolloClient<any>, callback: Callback): void => {
  const result = getTestAB({ name, client, location: window.location });
  if ('new' === result?.toLowerCase()) {
    callback();
  }
};
